import { render } from "./LikeIcon.vue?vue&type=template&id=6a659da1&scoped=true"
import script from "./LikeIcon.vue?vue&type=script&lang=js"
export * from "./LikeIcon.vue?vue&type=script&lang=js"

import "./LikeIcon.vue?vue&type=style&index=0&id=6a659da1&lang=scss&scoped=true"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a659da1"]])

export default __exports__